import { Container, Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import useQuery from '../../hooks/useQuery';
const DialogDetail = () => {
  const query = useQuery();
  const title = query.get('title');
  const id = query.get('id');
  const thumbnail = query.get('thumbnail');
  const jenis = query.get('jenis');
  const ringkasan = query.get('ringkasan');
  const startdate = query.get('startdate');
  const attachment = JSON.parse(query.get('attachment'));

  const [imgNotFound, setImgNotFound] = React.useState(false);
  // eslint-disable-next-line
  const [imgProps, setImgProps] = React.useState({ width: 0, height: 0 });

  const [orientation, setOrientation] = React.useState('column');

  const onLoadImage = ({ target }) => {
    const { naturalHeight, naturalWidth } = target;
    setImgProps({ width: naturalWidth, height: naturalHeight });
    setImgNotFound(false);
    if (naturalHeight < naturalWidth) return setOrientation('column');
    return setOrientation('row');
  };

  return (
    <Container>
      <Stack m={4} spacing={2} direction='column'>
        {orientation === 'row' && (
          <>
            <Typography variant='h4'>{title}</Typography>
            <Divider />
          </>
        )}

        <Stack direction={orientation} spacing={4}>
          <Stack sx={{ flex: 1.5 }} spacing={2}>
            {orientation === 'column' && (
              <Stack>
                <Typography variant='h4'>{title}</Typography>
              </Stack>
            )}
            {orientation === 'column' && (
              <Stack>
                <Divider />
              </Stack>
            )}

            {/* <Image
              onError={() => setImgDefault('/assets/loading_image.jpg')}
              onLoadingComplete={onLoadImage}
              src={imgDefault || `https://storage.googleapis.com/keshif_project/${id}.png`}
              layout='responsive'
              width={imgProps.width}
              height={imgProps.height}
              placeholder='blur'
              blurDataURL='/assets/loading_image.jpg'
            /> */}

            {imgNotFound ? (
              <img alt='Thumbnail' src={`/repository/assets/loading_image.jpg`} width='100%' height='auto' />
            ) : (
              <img
                alt='Thumbnail From Server'
                onError={() => {
                  setImgNotFound(true);
                  setOrientation('row');
                }}
                onLoad={onLoadImage}
                src={thumbnail}
                width='100%'
                height='auto'
              />
            )}

            {orientation === 'column' && <Divider />}
          </Stack>

          <Stack sx={{ flex: 2 }} direction='column' spacing={2}>
            <Typography variant='h5'>Description</Typography>
            <Typography>metadata:</Typography>
            <Typography>title: {title}</Typography>
            <Typography>thumbnail: {thumbnail}</Typography>
            <Typography>jenis: {jenis}</Typography>
            <Typography>startdate: {startdate}</Typography>
            <Typography>attachment: {attachment}</Typography>
            <Typography variant='caption'>Dummy view</Typography>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

export default DialogDetail;
